import Routes, { SECURITY_PATH } from "routing/Routes";
import SecurityPageEntry from "components/security/SecurityPageEntry";
import DEFAULT_ENTERPRISE_NAV_ITEM from "components/navigation/DefaultEnterpriseNavItem";
const routes = [{ path: `${SECURITY_PATH}/*`, component: SecurityPageEntry }];
export const DEFAULT_SECURITY_NAV_ITEM = {
  description: "Security",
  titleKey: "navigation:main.security",
  position: { after: DEFAULT_ENTERPRISE_NAV_ITEM.description },
  children: [
    { path: Routes.SECURITY.OVERVIEW, description: "Overview", titleKey: "navigation:security.overview" },
    {
      path: Routes.SECURITY.USER_ACTIVITY,
      description: "User Activity",
      titleKey: "navigation:security.user_activity"
    },
    {
      path: Routes.SECURITY.HOST_ACTIVITY,
      description: "Host Activity",
      titleKey: "navigation:security.host_activity"
    },
    {
      path: Routes.SECURITY.NETWORK_ACTIVITY,
      description: "Network Activity",
      titleKey: "navigation:security.network_activity"
    },
    { path: Routes.SECURITY.ANOMALIES, description: "Anomalies", titleKey: "navigation:security.anomalies" }
  ]
};
const pluginExports = {
  routes
};
export default pluginExports;
